import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgendaRoutingModule } from './agenda-routing.module';
import { MinhaAgendaComponent } from './pages/minha-agenda/minha-agenda.component';
import { AlarmeCompromissoComponent } from './componentes/alarme-compromisso/alarme-compromisso.component';
import { SemanalComponent } from './componentes/semanal/semanal.component';
import { DiarioComponent } from './componentes/diario/diario.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
    declarations: [
        MinhaAgendaComponent,
        AlarmeCompromissoComponent,
        SemanalComponent,
        DiarioComponent
    ],
    exports: [
        DiarioComponent
    ],
    imports: [
        CommonModule,
        AgendaRoutingModule,
        ComponentesModule,
        ReactiveFormsModule
    ]
})
export class AgendaModule { }
